import React from 'react';

/** A small drawing of the dashboard (sidebar, figures, chart, donut) used to preview a theme or accessibility choice. */
export function MiniDashboard({ variant = 'light', accent = '#079765', large = false, contrast = false }) {
  return (
    <div className={`st-mini ${variant} ${contrast ? 'contrast' : ''} ${large ? 'large' : ''}`} style={{ '--mini-acc': accent }} aria-hidden="true">
      <div className="st-mini-side">
        <b>TeleCalX</b>
        <i className="ws" />
        {Array.from({ length: 7 }).map((_, n) => <i key={n} className={n === 0 ? 'on' : ''} />)}
      </div>
      <div className="st-mini-main">
        <div className="st-mini-top"><i /><i /><i /></div>
        <div className="st-mini-cards">{['#2563eb', '#9333ea', accent, '#f59e0b'].map((c) => <span key={c}><i style={{ background: c }} /><b /></span>)}</div>
        <div className="st-mini-body">
          <svg viewBox="0 0 120 44" preserveAspectRatio="none"><polyline points="0,34 15,28 30,31 45,20 60,24 75,14 90,18 105,9 120,12" fill="none" stroke="#2563eb" strokeWidth="2" />
            <polyline points="0,40 15,36 30,38 45,30 60,33 75,26 90,29 105,22 120,25" fill="none" stroke={accent} strokeWidth="2" /></svg>
          <span className="st-mini-donut" />
          <div className="st-mini-bars">{[70, 45, 85, 30].map((w) => <i key={w} style={{ width: `${w}%` }} />)}</div>
        </div>
      </div>
    </div>
  );
}

/** Preview tiles under a choice: each a drawing and a caption; the current one is highlighted. */
export function PreviewRow({ items }) {
  return (
    <div className="st-previews">
      {items.map((p) => (
        <button type="button" key={p.key} className={`st-preview ${p.current ? 'on' : ''}`} onClick={p.onClick} disabled={!p.onClick}>
          {p.drawing}
          <span>{p.label}</span>
        </button>
      ))}
    </div>
  );
}
